import * as actionTypes from "../../actionLabels/index";


export const fetchBuyerOutsPaymtDetailData = (data) => ({
  type: actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA,
  payload: data
});

export const fetchBuyerOutsPaymtDetailDataSuccess = (data) => ({
  type: actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_SUCCESS,
  payload: data
});

export const fetchBuyerOutsPaymtDetailDataFailure = (error) => ({
  type: actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_FAILURE,
  payload: error
});

export const fetchBuyerOutsPaymtDetailDataApiCall = (status) => ({
  type: actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_API_CALL,
  payload: status
});

export const fetchBuyerOutsPaymtDetailDataExportSuccess = (data) => ({
  type: actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_EXPORT_SUCCESS,
  payload: data
});